import * as RPopover from "@radix-ui/react-popover";
import { type ReactElement, type ReactNode } from "react";

import { cn } from "../utils/cn";

export interface PopoverProps {
  /** The element that opens it; must be a focusable button. */
  trigger: ReactElement;
  children: ReactNode;
  /** Names the panel for screen readers. */
  "aria-label": string;
  align?: "start" | "center" | "end";
  className?: string;
}

/** Small panel of extra details opened by a button (Radix Popover): opens on
 * click, tap and keyboard, closes on Esc or an outside click. Not for
 * pickers (Combobox) or menus (DropdownMenu). */
export function Popover({ trigger, children, align = "start", className, ...aria }: PopoverProps): ReactElement {
  return (
    <RPopover.Root>
      <RPopover.Trigger asChild>{trigger}</RPopover.Trigger>
      <RPopover.Portal>
        <RPopover.Content
          align={align}
          sideOffset={4}
          aria-label={aria["aria-label"]}
          className={cn(
            "z-50 max-w-sm rounded-md border border-border-default bg-neutral-0 p-3 text-sm text-text-primary shadow-lg",
            "focus-visible:outline-none",
            className,
          )}
        >
          {children}
        </RPopover.Content>
      </RPopover.Portal>
    </RPopover.Root>
  );
}
